// Original file: /var/jenkins_home/workspace/tingle.1577b1d1-c40d-4ea8-a781-ec5cab8bfc36/workspace/proto/artist_watchlist.proto

export const ErrorType = {
  BAD_FORMAT: 'BAD_FORMAT',
  NOT_FOUND: 'NOT_FOUND',
  INTERNAL: 'INTERNAL',
  NOT_AUTHORIZED: 'NOT_AUTHORIZED',
} as const;

export type ErrorType =
  | 'BAD_FORMAT'
  | 0
  | 'NOT_FOUND'
  | 1
  | 'INTERNAL'
  | 2
  | 'NOT_AUTHORIZED'
  | 3

export type ErrorType__Output = typeof ErrorType[keyof typeof ErrorType]
